module.exports = __webpack_public_path__ + "static/media/loader.e830aece.svg";